import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  .react-joyride {\n    display: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  line-height: 22px;\n  padding: 2px 4px;\n  display: inline-block;\n  font-weight: 600;\n  border-radius: 5px;\n  margin-left: 4px;\n  margin-right: 4px;\n  cursor: pointer;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useEffect, useState } from 'react';
import reactStringReplace from 'react-string-replace';
import { camelCase } from 'lodash';
import { LearnTips, LearnTipModal, styled } from '@acorns/web-components';
import { AcornsIcon } from '@acorns/icons';
import { theme } from '@acorns/web-components';
import MediaQuery from 'react-responsive';
import { useAnalyticsClient } from '../analytics';
import { LEARN_TIPS_DISABLED } from './constants';
import { LearnTipExited, LearnTipLabelViewed, LearnTipTapped, LearnTipViewed } from './events';
var Tip = styled.span(_templateObject(), function (props) {
  return props.hasSeenTip ? "background: ".concat(props.theme.colors.ivory, ";") : 'background: rgba(116, 201, 71, 0.3);';
});
var TipContainer = styled.div(_templateObject2());

var hasLearnTip = function hasLearnTip(substitutedString) {
  return substitutedString.includes('(tooltip-def://');
};

var addLearnTipToString = function addLearnTipToString(learnTipString, strings, learnTips, screen) {
  var _learnTipString$match;

  var analytics = useAnalyticsClient();

  var _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      visibleTip = _useState2[0],
      setVisibleTip = _useState2[1];

  var updatedString = learnTipString; //An example string that should match here is "Your Later [portfolio](tooltip-def://portfolio) is selected based on your age and [timeline to retirement](tooltip-def://timeline_to_retirement)."
  //the regex pulls out [portfolio](tooltip-def://portfolio) and [timeline to retirement](tooltip-def://timeline_to_retirement) as tips from the string

  var tips = (_learnTipString$match = learnTipString.match(/\[.*?\]\(tooltip-def:\/\/(.*?)\)/g)) !== null && _learnTipString$match !== void 0 ? _learnTipString$match : [];
  var userAllowsTips = localStorage.getItem(LEARN_TIPS_DISABLED) !== 'true'; //this regex would extract the value from the parentheses, excluding tooltip-def:// so timeline to retirement from [timeline_to_retirement](tooltip-def://timeline_to_retirement), then the last parentheses is removed

  var getTipKey = function getTipKey(tip) {
    return tip.split('tooltip-def://')[1].slice(0, -1);
  }; //this regex would extract the value from the brackets, so [timeline to retirement] from [timeline to retirement](tooltip-def://timeline_to_retirement), then the brackets get sliced


  var getTipDef = function getTipDef(tip) {
    var _tip$match;

    return ((_tip$match = tip.match(/\[(.+?)\]/g)) === null || _tip$match === void 0 ? void 0 : _tip$match[0].slice(1, -1)) || '';
  };

  var getLocalStorageKey = function getLocalStorageKey(tipKey) {
    return camelCase(tipKey) + 'LearnTip';
  };

  var LEARN_TIPS_STORAGE_KEY = 'hasSeenLearnTip';
  var hasSeenLearnTip = localStorage.getItem(LEARN_TIPS_STORAGE_KEY) === 'true';
  useEffect(function () {
    tips.forEach(function (tip) {
      var tipKey = getTipKey(tip);
      var tipData = learnTips[tipKey];
      var showTip = tipData && userAllowsTips;

      if (showTip) {
        var _analytics$track;

        (_analytics$track = analytics.track) === null || _analytics$track === void 0 ? void 0 : _analytics$track.call(analytics, 'Container Viewed', LearnTipLabelViewed(tipData['tracking'], screen));
      }
    });
  }, [learnTips]);
  tips.forEach(function (tip) {
    var tipDef = getTipDef(tip);
    var tipKey = getTipKey(tip);
    var localStorageKey = getLocalStorageKey(tipKey);
    var currentTipState = localStorage.getItem(localStorageKey);
    var tipData = learnTips[tipKey];

    var handleClick = function handleClick() {
      var _analytics$track2, _analytics$track3;

      (_analytics$track2 = analytics.track) === null || _analytics$track2 === void 0 ? void 0 : _analytics$track2.call(analytics, 'Button Tapped', LearnTipTapped(tipData['tracking'], screen));
      setVisibleTip(tip);
      (_analytics$track3 = analytics.track) === null || _analytics$track3 === void 0 ? void 0 : _analytics$track3.call(analytics, 'Container Viewed', LearnTipViewed(tipData['tracking'], screen));
      if (!currentTipState) localStorage.setItem(localStorageKey, 'current');
    };

    var _handleComplete = function handleComplete() {
      var _analytics$track4;

      setVisibleTip(undefined);
      (_analytics$track4 = analytics.track) === null || _analytics$track4 === void 0 ? void 0 : _analytics$track4.call(analytics, 'Button Tapped', LearnTipExited(tipData['tracking'], screen));
      localStorage.setItem(localStorageKey, 'true');
      localStorage.setItem(LEARN_TIPS_STORAGE_KEY, 'true');
    };

    var step = [{
      badgeIcon: hasSeenLearnTip ? AcornsIcon.Icon.ProductGrowFv : undefined,
      badgeText: 'New',
      title: strings[tipData === null || tipData === void 0 ? void 0 : tipData['title']],
      body: strings[tipData === null || tipData === void 0 ? void 0 : tipData['body']],
      placement: 'bottom',
      target: "#tip_".concat(tipKey),
      pointerAdjustment: '48%',
      showButtons: false,
      borderRadius: theme.borderRadius.small,
      dataTestId: tipData === null || tipData === void 0 ? void 0 : tipData['tracking']
    }];
    var showTip = tipData && userAllowsTips;
    updatedString = showTip ? reactStringReplace(updatedString, tip, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MediaQuery, {
        minWidth: theme.breakpoints.sm + 1
      }, /*#__PURE__*/React.createElement(LearnTips, {
        steps: step,
        run: tip === visibleTip,
        disableScrolling: true,
        handleComplete: function handleComplete(status) {
          if (status.action === 'reset') {
            _handleComplete();
          }
        }
      })), /*#__PURE__*/React.createElement(MediaQuery, {
        maxWidth: theme.breakpoints.sm
      }, /*#__PURE__*/React.createElement(LearnTipModal, {
        isOpen: tip === visibleTip,
        step: step[0],
        handleClose: _handleComplete
      })), /*#__PURE__*/React.createElement(Tip, {
        id: "tip_".concat(tipKey),
        "data-testid": "tip_".concat(tipKey, "_text"),
        hasSeenTip: currentTipState === 'true' || currentTipState === 'current',
        onClick: handleClick
      }, tipDef));
    }) : updatedString.replace(tip, tipDef);
  });
  return /*#__PURE__*/React.createElement(TipContainer, null, updatedString);
};

export { hasLearnTip, addLearnTipToString };